import { P } from "AbstractElements";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Clock } from "react-feather";

// Modal informasi bahwa proses audit sedang berjalan / sudah masuk antrean.
const AuditProcessingModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered toggle={onClose}>
      <ModalHeader toggle={onClose} className="border-0 pb-0">
        <div className="d-flex align-items-center gap-2">
          <span
            className="rounded-circle d-inline-flex align-items-center justify-content-center"
            style={{ width: 36, height: 36, background: "#e0f2fe" }}
          >
            <Clock size={16} color="#0369a1" />
          </span>
          <span>Proses Audit Sedang Berjalan</span>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="rounded-4 border border-primary-subtle bg-primary-subtle p-3">
          <P className="mb-0">
            Audit sudah masuk antrean dan sedang diproses oleh sistem. Hasil akan
            muncul secara otomatis setelah selesai.
          </P>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          Tutup
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AuditProcessingModal;
